import React from 'react';
import { DOCUMENT_REQUEST_CATEGORY } from 'common/constants/process-management';
import CurrentRequestedDocumentTable from './CurrentRequestedDocumentTable';
import { CurrentRequestedDocumentsAndQuestionsProps, DocumentProgress } from './types';

const CurrentRequestedDocument = ({ currentInformationRequests }: CurrentRequestedDocumentsAndQuestionsProps) => {
  const documents = currentInformationRequests.find(request => request.category === DOCUMENT_REQUEST_CATEGORY);
  if (!documents?.id) {
    return null;
  }
  const filteredDocuments = {
    ...documents,
    responsible_users:
      documents.responsible_users.map(user => ({
        id: user.id,
        email: user.email,
        full_name: user.full_name,
      })) || [],
    progress:
      documents.progress.filter(
        (item): item is DocumentProgress => 'files' in item && 'is_uploaded' in item && 'tags' in item
      ) || [],
  };

  return <CurrentRequestedDocumentTable documents={filteredDocuments} />;
};

export default CurrentRequestedDocument;
